/**
 * Component: Navigator share
 * ------------------------------------------------------------------------------
 *
 * @namespace navigatorShare
 */
import cssClasses from '~/helpers/cssClasses';
import {on} from '~/helpers/utils';

/**
 * DOM selectors.
 */
const selectors = {
  toggleSelector: '[js-example="toggle"]',
  share: '[js-product-form="share"]',
};

/**
 * Create a new example object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    share: document.querySelector(selectors.share),
  };

  /**
   * Initialise component.
   */
  function init() {
    navigatorShare();
  }

  /**
   * Navigator share.
   */
  function navigatorShare() {
    const title = nodeSelectors.share.dataset.title;
    const url = document.querySelector('link[rel="canonical"]').getAttribute('href');

    if (!isMobileDevice) {
      nodeSelectors.share.classList.add(cssClasses.hidden);
    }

    on('click', nodeSelectors.share, async () => {
      if (navigator.share !== undefined) {
        try {
          await navigator.share({
            title,
            url,
          });
        } catch (error) {
          window.console.log(error);
        }
      }
    });
  }

  /**
   * Check mobile device.
   */
  function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
